import { useCallback, useEffect, useMemo } from "react";
import { useLocation, useSearchParams } from "react-router-dom";

import {
  fetchProductsAtom,
  productsInfoAtom,
  productsLoadingStatusAtom,
} from "../atom/priceHistory";
import { useAtom } from "jotai";

const useUpdatePriceHistory = (locationState) => {

  const location = useLocation();
  const [searchParams] = useSearchParams();
  const [, fetchProducts] = useAtom(fetchProductsAtom);
  const [productsLoadingStatus, setProductsLoadingStatus] = useAtom(
    productsLoadingStatusAtom,
  );
  const [productsInfo] = useAtom(productsInfoAtom);

  const removeFromSearch = useCallback(() => {
    const params = new URLSearchParams();

    if (locationState) {
      const queryString = locationState.split("?")[1];
      const locationParams = new URLSearchParams(queryString);
      const pgId = locationParams.get("pgId");
      const period = locationParams.get("period") || "3M";

      if (pgId) {
        params.set("pgId", pgId);
        params.set("period", period);
      }
    } else {
      const pathnameParts = location.pathname.split("/");
      const lastPart = pathnameParts[pathnameParts.length - 1];

      const pgIdMatch = lastPart.match(/-(\d+)$/);
      const pgId = pgIdMatch ? pgIdMatch[1] : null;
      const period = searchParams.get("period") || "3M";

      if (pgId) {
        params.set("pgId", pgId);
        params.set("period", period);
      }
    }

    return params.toString();
  }, [locationState, location.pathname, location.search, searchParams]);


  const settingProducts = useCallback(
    async (queryString) => {
      try {
        const params = new URLSearchParams(queryString);
        const pgId = params.get("pgId");
        const period = params.get("period");

        if (pgId) {
         
          setProductsLoadingStatus("loading");
          await fetchProducts(queryString);
        }
      } catch (e) {
        console.error("Error fetching price history:", e);
      }
    },
    [fetchProducts, setProductsLoadingStatus],
  );

  useEffect(() => {
    const updatedSearch = removeFromSearch();

    if (updatedSearch) {
      settingProducts(updatedSearch);
    }
  }, [searchParams, removeFromSearch, settingProducts]);

  const data = useMemo(
    () => ({
      productsInfo,
      productsLoadingStatus,
    }),
    [productsInfo, productsLoadingStatus],
  );

  return data;
};

export default useUpdatePriceHistory;
